<template>
  <v-app  :class="this.$route.name" >
    <v-content>
      <Menu @tratarNotificacao="tratarNotificacao" @abrirModalNotificacao="abrirModal"></Menu>
      <loading></loading>
      <transition name="fade" appear mode="out-in">
        <div style="position: relative;">
          <Notification  :abrirModal="abrirNotificacao" @fecharModalNotificacao="abrirNotificacao = false" :notificationList="notificationList"/>
          <router-view />
        </div>
      </transition>
    </v-content>
  </v-app>
</template>

<script>
import Menu from './components/shared/Menu'
import Loading from './components/shared/Loading'
import Notification from './components/shared/Notification.vue';

export default {
  name: 'App',
  components: {
    Menu,
    Loading,
    Notification
  },
  data() {
    return {
      notificationList: [],
      abrirNotificacao: false,  
    }
  },
  methods: {
    tratarNotificacao: function(data) {
      this.notificationList = [...data];
    }, 
    abrirModal() {
      this.abrirNotificacao = true
    }
  }
}
</script>


<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s
}

.fade-enter, .fade-leave-to {
  opacity: 0
}

#app {
  background: #EEEEEE
}
</style>



// WEBPACK FOOTER //
// src/App.vue